import React, { Component } from 'react';
import '../../../../sass/apps/commerce/mobile/personal_upgrade.scss';
import CheckoutView from '../checkout/view';
import TiledVariationView from '../products/tiled_variation/view';
import OriginalPersonalProductsView from '../products/personal_products_view';
import ExtraListings from '../products/ExtraListings';
import ProPackagesLink from '../products/pro_packages_link';

class ViewController extends Component {
  constructor(props) {
    super(props);
    this.backToMyAccountLink = document.querySelector('#back-navigation-link');
    this.upgradeInfo = document.querySelector('.upgrade-container--mobile');
  }

  render() {
    const PersonalProductsView =
      this.props.context.context == 'contact_advertiser' &&
      !this.props.experiments.success_guarantee_experiment_mobile
        ? TiledVariationView
        : OriginalPersonalProductsView;

    return (
      <section className="commerce" data-testid="commerce">
        <PersonalProductsView
          {...this.props}
          advertId={this.props.checkoutCart.advert_id}
          updateCart={this.props.updateCart}
          currentProduct={this.props.currentProduct}
          localisations={this.props.localisations}
          experiments={this.props.experiments}
        />
        {this.props.extraListingsAvailable ? (
          <ExtraListings
            extraListingsCount={this.props.extraListingsCount}
            extraListingsTotal={this.props.extraListingsTotal}
            extraListingsSelectedId={this.props.extraListingsSelectedId}
            addExtraListings={this.props.addExtraListings}
            currentProduct={this.props.currentProduct}
            availableExtraListings={this.props.availableExtraListings}
            gaLabel={this.props.staticData.site.loginReturnPath}
            gaAction={this.props.pageData.name}
            localisations={this.props.localisations}
            currencySymbol={this.props.staticData.site.currency_symbol}
            siteId={this.props.staticData.site.id}
            addDefaultExtraListings={this.props.addDefaultExtraListings}
          />
        ) : (
          <div className="commerce__pro-packages-wrapper">
            <ProPackagesLink
              product_description={this.props.checkoutCart.product_description}
              classBlock={'commerce'}
              context={this.props.staticData.miscellaneous.context}
              localisations={this.props.localisations}
            />
          </div>
        )}
        {this.props.context.context != 'contact_advertiser' ||
        this.props.experiments.success_guarantee_experiment_mobile ? (
          <CheckoutView
            {...this.props}
            localisations={this.props.localisations}
            beforeSubmitErrorCheck={this.props.beforeSubmitErrorCheck}
            walletButtons={this.props.walletButtons}
            experiments={this.props.experiments}
          />
        ) : null}
      </section>
    );
  }
}

export default ViewController;
